var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stripe"},[_c('p',{staticClass:"body-2",staticStyle:{"margin-bottom":"0px"}},[_vm._v(" Estás monitoreando en tiempo real a: "),_c('strong',{staticClass:"heading-h6"},[_vm._v(_vm._s(_vm.profile.names)+" "+_vm._s(_vm.profile.surnames))])]),_c('a-button',{on:{"click":_vm.handleCLose}},[_vm._v("Salir de supervisión")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }